@for (child of data.batch; track child) {
	<div>
		<div>{{ getLabel(child.key) }}</div>
		<app-linechart [props]="child.linechartProps" [gridHeight]="data.gridHeight"></app-linechart>
	</div>
}
